import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';
import { API_BASE_URL } from '../api';
import './DashboardPage.css';

/** Create a test suite under a project. Reached at /projects/:projectId/suites/new. */
function SuiteFormPage() {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [projectName, setProjectName] = useState('');
  const [formData, setFormData] = useState({ name: '', description: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const savingRef = useRef(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE_URL}/projects/${projectId}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => {
        if (!cancelled && p) setProjectName(p.name);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [projectId, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (savingRef.current) return;
    savingRef.current = true;
    setSaving(true);
    setError('');
    try {
      const response = await fetch(`${API_BASE_URL}/suites`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId: parseInt(projectId, 10), ...formData }),
      });
      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        navigate(`/projects/${projectId}/suites/${data.id}`);
      } else {
        setError(data.error || 'Failed to create test suite.');
        savingRef.current = false;
        setSaving(false);
      }
    } catch (err) {
      console.error('Error creating test suite:', err);
      setError('Error creating test suite: ' + err.message);
      savingRef.current = false;
      setSaving(false);
    }
  };

  return (
    <div className="dashboard-page">
      <div className="container">
        <Breadcrumb
          items={[
            { label: 'Projects', to: '/projects' },
            { label: projectName || `Project ${projectId}`, to: `/projects/${projectId}` },
            { label: 'New suite' },
          ]}
        />
        <h1>New Test Suite</h1>

        {error && <div className="error-banner">{error}</div>}

        <div className="card">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="suiteName">Suite Name *</label>
              <input
                id="suiteName"
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="suiteDescription">Description</label>
              <textarea
                id="suiteDescription"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows="3"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? 'Creating...' : 'Create Test Suite'}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate(`/projects/${projectId}`)}
                disabled={saving}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SuiteFormPage;
